import React from 'react';
import ApiRequest from '../ApiRequest';
import Event from '../Event';
import hat from 'hat';

export default class ApplicationSorter extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            status: 0,
            loading: null
        };

        this.id = 'ApplicationSorter_' + hat();
    }

    componentDidMount() {
        if (this.props.user && this.props.user.application_uid && this.props.user.status) {
            this.setState({status: this.props.user.status});
        }

        Event.on(`ProfileView.application.moved_${this.props.user.uid}`, (data) => {
            if (data.status && data.application_uid) {
                this.handleSelection(data.status, data.application_uid, () => {
                    if (data.cb) {
                        data.cb();
                    }
                });
            }
        }, this.id);
    }

    componentWillReceiveProps(props) {
        if (props.user) {
            this.setState({status: props.user.status});
        }
    }

    componentWillUnmount() {
        Event.off(`ProfileView.application.moved_${this.props.user.uid}`, this.id);
    }

    handleSelection(status, application_uid = null, cb = null) {
        this.setState({loading: status});
        let request = new ApiRequest();
        let user = this.props.user;
        request.put(`job/application`, {
            status,
            application_uid: application_uid ? application_uid : user.application_uid
        }, (err, res) => {
            if (res && res.body && res.body.success) {
                if (cb) {
                    cb();
                }
                Event.fire('application.moved', {
                    oldStatus: this.state.status,
                    newStatus: status,
                    user
                }, 'application.moved');
                this.setState({loading: false, status});
            } else {
                this.setState({loading: false});
            }
        });
    }

    sizeClass() {
        return this.state.status === 0 ? 'col-md-4' : 'col-md-6';
    }

    buttons() {
        let buttons = [
            {status: 1, label: 'Yes'},
            {status: 2, label: 'Maybe'},
            {status: 3, label: 'No'}
        ];
        return buttons.map((button, index) => {
            return button.status !== this.state.status ? (
                <div className={this.sizeClass() + ' p-1'} key={this.props.user.uid + '_' + this.props.user.application_uid + '_' + index}>
                    <button onClick={() => this.handleSelection(button.status)}
                        type="button"
                        className={"btn btn-secondary btn-xs btn-block p-0"}>
                            {this.state.loading && this.state.loading === button.status ?
                                <i className="fa fa-refresh fa-spin"></i> : button.label}
                </button>
                </div>
            ) : null;
        });
    }

    wrappedClasses() {
        return this.props.wrapped ? 'mb-3' : 'application-sorter-buttons p-0 ml-2 pl-2 '
    }

    render() {
        return this.props.user && this.props.user.application_uid ? (
            <div className="row">
                <div className={"btn-group col-md-12 " + this.wrappedClasses() + (this.props.className ? this.props.className : '')} role="group">
                    {this.buttons()}
                </div>
            </div>
        ) : null;
    }
}